import { createAsyncThunk } from "@reduxjs/toolkit";

import { type ProductClient } from "@fitness-app/data-models/entities/ProductClient";

import { getLoggedUser } from "../../../helpers/getLoggedUser";
import { getViewerId, isViewingSomeoneElse } from "../../../helpers/getViewerId";
import { type AsyncThunkCreator } from "../../../index";
import { CLIENT_PRODUCTS_SLICE_NAME } from "../types";

type Payload = void;

export const fetchClientProducts = createAsyncThunk<ProductClient[], Payload, AsyncThunkCreator<string>>(
  `${CLIENT_PRODUCTS_SLICE_NAME}/fetchClientProducts`,
  async (_, { rejectWithValue, extra: { db, auth } }) => {
    // `product_client` rows are anchored on the contact e-mail, not the auth user id, so a preview
    // has to swap in the viewed client's e-mail — the staff member's own matches nothing.
    let email = (await getLoggedUser(auth)).email;

    if (isViewingSomeoneElse()) {
      const { error: traineeError, data: trainee } = await db
        .from("trainee")
        .select("email")
        .eq("userId", await getViewerId(auth))
        .single();

      if (traineeError) {
        return rejectWithValue(traineeError.message);
      }

      email = trainee.email;
    }

    const { error, data } = await db
      .from("product_client")
      .select("*")
      .order("createdAt", { ascending: false })
      .eq("email", email)
      .returns<ProductClient[]>();

    if (error) {
      return rejectWithValue(error.message);
    }

    return data;
  },
);
